<template>
  <div id="home_slider" class="position-relative gray-gradient-base">
    <Loader v-if="!display" />
    <Error v-if="error" />
    <VueSlickCarousel
      :arrows="false"
      :infinite="true"
      :dots="false"
      :touchThreshold="5"
      :rtl="direction"
      ref="slider1"
      @afterChange="pageChange"
      :autoplay="true"
      :autoplaySpeed="6000"
      :pauseOnHover="false"
      :fade="true"
    >
      <div class="" v-for="(card,i) in info" :key="i">
        <div class="slider-height position-relative" :style="{ 'background': `url(${ $store.state.window > 600 ? card.image : card.smallImage }) no-repeat`}" :class="$store.state.window < 550 ? 'flex-center' : 'flex-start-center'">
          <home-card :data="card" />
        </div>
      </div>
    </VueSlickCarousel>
    <div class="quick-link-container">
      <div :class="[lang === 'ar' ? 'bold-ar' : 'bold-en', 'header']"><div>{{$t('quick')}}</div></div>
      <div class="body">
        <div class="child right-border d-flex justify-content-center">
          <router-link to="#mtn_apps">
            <a>
              <div>
                <img src="../../assets/icons/mtnapps.svg" style="height: 41.5px">
                <br>
                <div class="mt-2">{{$t('ourApps')}}</div>
              </div>
            </a>
          </router-link>
        </div>
        <div class="child right-border d-flex justify-content-center">
          <router-link to="/reserve-number">
            <a>
              <div>
                <img src="../../assets/icons/reservationNumber.svg" style="height: 43.5px">
                <br>
                <div class="mt-2">{{$t('reserve')}}</div>
              </div>
            </a>
          </router-link>
        </div>
        <div class="child d-flex justify-content-center">
          <router-link to="/products/payment/62">
            <a>
              <div>
                <img src="../../assets/icons/prices.svg" style="height: 41.5px">
                <br>
                <div class="mt-2">{{$t('prices')}}</div>
              </div>
            </a>
          </router-link>
        </div>
      </div>
    </div>
    <div :class="[lang === 'ar' ? 'social-icons-left right-dir' : 'social-icons-right left-dir', 'social-media-links']">
      <div v-for="(item,index) in social" :key="index" class="social-icon">
        <a :href="item.url" target="_blank">
          <svg width="30" height="30" viewBox="0 0 40 40" @mouseover="hovering(index)" @mouseout="removeHovering(index)">
            <path :d="item.points" :transform="item.transform" :fill="item.color" />
          </svg>
        </a>
      </div>
    </div>
    <div v-if="$store.state.window > 600" :class="[lang === 'ar' ? 'current-all-right right-dir' : 'current-all-left','current-all']">
      <span v-if="info.length > 0" class="current">
        <span v-if="numberLength === 1">0</span>{{currentSlide}}
        <span class="all">/ <span v-if="numberLength === 1">0</span>{{Math.ceil(info.length)}}</span>
      </span>
    </div>
  </div>
</template>

<script>
import HomeCard from '../cards/HomeCard'
import VueSlickCarousel from 'vue-slick-carousel-rtl'
import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-rtl.css'
import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-theme.css'
import facebook from '../../assets/icons/face.svg'
import instagram from '../../assets/icons/Insta.svg'
import linkedIn from '../../assets/icons/linked-in.svg'
import $ from 'jquery'
import Loader from '../LoaderBtn/Loader'
import Error from '../errorHandle/Error'
export default {
  name: 'HomeSlider',
  props: {
    data: {
      type: Array
    },
    show: Boolean,
    error: Boolean
  },
  components: { HomeCard, VueSlickCarousel, Loader, Error },
  data () {
    return {
      info: [],
      current: 1,
      active1: 0,
      active2: '',
      visited: [0],
      currentSlide: 1,
      numberLength: 1,
      direction: false,
      lang: this.$lang,
      links: [instagram, linkedIn, facebook],
      social: [{ url: '', points: 'M11.25,40A11.25,11.25,0,0,1,0,28.75V11.25A11.25,11.25,0,0,1,11.25,0h17.5A11.25,11.25,0,0,1,40,11.25v17.5A11.25,11.25,0,0,1,28.75,40ZM3.5,11.25v17.5a7.758,7.758,0,0,0,7.75,7.75h17.5a7.758,7.758,0,0,0,7.75-7.75V11.25A7.758,7.758,0,0,0,28.75,3.5H11.25A7.758,7.758,0,0,0,3.5,11.25ZM17.407,31.759V21.693H13.75V17.529h3.657V14.355c0-3.611,2.151-5.6,5.442-5.6a22.151,22.151,0,0,1,3.224.281v3.545H24.258a2.082,2.082,0,0,0-2.348,2.25v2.7H25.9l-.639,4.164H21.91V31.759Z', color: '#FFCB05', transform: '', scale: '' },
        { url: '', points: 'M11.25,40A11.25,11.25,0,0,1,0,28.75V11.25A11.25,11.25,0,0,1,11.25,0h17.5A11.25,11.25,0,0,1,40,11.25v17.5A11.25,11.25,0,0,1,28.75,40ZM3.5,11.25v17.5a7.758,7.758,0,0,0,7.75,7.75h17.5a7.758,7.758,0,0,0,7.75-7.75V11.25A7.758,7.758,0,0,0,28.75,3.5H11.25A7.758,7.758,0,0,0,3.5,11.25ZM30.521,30.525H26.194v-6.8c0-1.62-.033-3.7-2.254-3.7-2.255,0-2.6,1.76-2.6,3.581v6.914H17.007V16.56h4.159v1.9h.061a4.558,4.558,0,0,1,4.1-2.255c4.39,0,5.2,2.89,5.2,6.643v7.671Zm-20.566,0V16.56h4.337V30.525ZM9.609,12.12a2.512,2.512,0,1,1,2.512,2.536A2.512,2.512,0,0,1,9.609,12.12Z', color: '#FFCB05', transform: '', scale: '' },
        { url: '', points: 'M20,11.982A10.255,10.255,0,1,0,30.252,22.238,10.238,10.238,0,0,0,20,11.982Zm0,16.923a6.667,6.667,0,1,1,6.666-6.667A6.679,6.679,0,0,1,20,28.905ZM33.063,11.563a2.392,2.392,0,1,1-2.392-2.392A2.386,2.386,0,0,1,33.063,11.563Zm6.791,2.428c-.152-3.2-.883-6.043-3.23-8.381s-5.176-3.07-8.379-3.231c-3.3-.187-13.2-.187-16.5,0C8.55,2.53,5.713,3.262,3.366,5.6S.3,10.777.135,13.982c-.187,3.3-.187,13.2,0,16.5.152,3.2.883,6.043,3.23,8.381s5.176,3.07,8.379,3.231c3.3.187,13.2.187,16.5,0,3.2-.152,6.041-.884,8.379-3.231s3.07-5.177,3.23-8.381c.187-3.3.187-13.192,0-16.494ZM35.589,34.028a6.75,6.75,0,0,1-3.8,3.8c-2.632,1.044-8.879.8-11.788.8s-9.165.232-11.788-.8a6.749,6.749,0,0,1-3.8-3.8c-1.044-2.633-.8-8.881-.8-11.791s-.232-9.167.8-11.791a6.749,6.749,0,0,1,3.8-3.8c2.632-1.044,8.879-.8,11.788-.8s9.165-.232,11.788.8a6.749,6.749,0,0,1,3.8,3.8c1.044,2.633.8,8.881.8,11.791S36.633,31.4,35.589,34.028Z', color: '#FFCB05', transform: 'translate(0.005 -2.238)', scale: '' },
        { url: '', points: 'M11.25,40A11.251,11.251,0,0,1,0,28.751V11.25A11.25,11.25,0,0,1,11.25,0h17.5A11.249,11.249,0,0,1,40,11.25v17.5A11.25,11.25,0,0,1,28.751,40ZM3.5,11.25v17.5a7.759,7.759,0,0,0,7.75,7.75h17.5a7.759,7.759,0,0,0,7.75-7.75V11.25a7.759,7.759,0,0,0-7.75-7.75H11.25A7.759,7.759,0,0,0,3.5,11.25ZM23.877,30.377c-.24-.181-4.521-2.893-6.088-4.219a1.143,1.143,0,0,1,.06-1.93c2.17-1.989,4.762-4.46,6.329-6.027.724-.724,1.447-2.412-1.567-.362l-8.5,5.726a3.541,3.541,0,0,1-2.773.06c-1.808-.542-3.919-1.265-3.919-1.265s-1.446-.9,1.025-1.868c3.686-1.506,17.024-7.031,20.134-8.319,0,0,2.17-.844,1.989,1.205-.06.844-.542,3.8-1.025,6.993l-1.507,9.464c-.172,1.237-.776,1.651-1.5,1.651A5.323,5.323,0,0,1,23.877,30.377Z', color: '#FFCB05', transform: '', scale: '' }
      ],
      display: this.show
    }
  },
  watch: {
    show (val) {
      this.display = val
    },
    error (val) {
      if (val === true) {
        this.display = true
      }
    }
  },
  created () {
    this.info = this.data
    this.getSocial(this.$store.state.links)
    this.$watch(() => {
      return this.$store.state.links
    }, (val) => {
      this.getSocial(val)
    })
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.styling()
    })
    this.$lang === 'ar' ? this.direction = true : this.direction = false
    this.numberLength = this.currentSlide.toString().length
    setTimeout(() => {
      this.styling()
      this.$lang === 'ar' ? $('#home_slider div#outer_card').css('margin-right', '4vw') : $('#home_slider div#outer_card').css('margin-right', '4vw')
      this.$lang === 'ar' ? $('#home_slider .child').css('font-family', 'Mtn-arabic-regular') : $('#home_slider .child').css('font-family', 'Mtn-regular')
      // this.$lang === 'ar' ? $('.current-all').css('right', '4vw') : $('.current-all').css('left', '4vw')
    })
  },
  methods: {
    getSocial (val) {
      for (let i = 0; i < val.length; i++) {
        if (val[i].type === 2) {
          this.social[1].url = val[i].link
        } else if (val[i].type === 1) {
          this.social[2].url = val[i].link
        } else if (val[i].type === 3) {
          this.social[0].url = val[i].link
        } else if (val[i].type === 0) {
          this.social[3].url = val[i].link
        }
      }
    },
    hovering (index) {
      for (let i = 0; i < this.social.length; i++) {
        if (index === this.social.indexOf(this.social[i])) {
          this.social[i].color = '#00678F'
        }
      }
      this.$forceUpdate()
    },
    removeHovering (index) {
      for (let i = 0; i < this.social.length; i++) {
        if (index === this.social.indexOf(this.social[i])) {
          this.social[i].color = '#FFCB05'
        }
      }
      this.$forceUpdate()
    },
    styling () {
      if (window.innerWidth > 900) {
        this.$lang === 'ar' ? $('ul.slick-dots').css('left', '-3%') : $('ul.slick-dots').css('right', '-3%')
      } else if (window.innerWidth <= 900 && window.innerWidth > 700) {
        this.$lang === 'ar' ? $('ul.slick-dots').css('left', '-5%') : $('ul.slick-dots').css('right', '-5%')
      } else if (window.innerWidth <= 700 && window.innerWidth > 500) {
        this.$lang === 'ar' ? $('ul.slick-dots').css('left', '-8%') : $('ul.slick-dots').css('right', '-8%')
      } else {
        this.$lang === 'ar' ? $('ul.slick-dots').css('left', '-12%') : $('ul.slick-dots').css('right', '-12%')
      }
    },
    checkPagination () {
      this.active2 = this.$refs.slider1.activeIndex
      if (this.active2 > this.active1) {
        this.current += 1
      } else {
        this.current -= 1
      }
      this.active1 = this.$refs.slider1.activeIndex
    },
    pageChange (slide) {
      this.currentSlide = slide + 1
      this.numberLength = this.currentSlide.toString().length
    }
  }
}
</script>

<style lang="scss">
#home_slider{
  height: 100vh;
  min-height: 700px;
}
#home_slider .current-all {
  bottom: 4px!important;
}
.current-all-left{
  left: 4vw !important;
}
.current-all-right{
  right: 4vw !important;
}
.social-icons-right{
  right: 40px;
}
.social-icons-left{
  left: 40px;
}
.slider-height {
  height: 100vh;
  background-size: cover!important;
  background-position: center!important;
  //min-height: 441px!important;
  min-height: 700px!important;
}
.quick-link-container{
  direction: ltr;
  position: absolute;
  bottom: 30px;
  transform: translateX(-50%);
  left: 50%;
  width: 435px;
  height: 155px;
  background: linear-gradient(to bottom, rgba(255,255,255,.4), rgba(255,255,255,.6));
  backdrop-filter: blur(15px);
  border: 3px solid rgba(255,255,255,.5);
  border-radius: 25px;
  .header {
    color: #FFCB05;
    font-size: 16.5px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .body{
    width: 100%;
    height: calc(100% - 40px);
    display: flex;
    .child{
      width: 33.333%;
      height: 90%;
      padding-top: 1rem;
    }
    .right-border{
      border-right: 2.5px solid rgba(255,255,255,.5);
    }
  }
}
.social-media-links{
  position: absolute;
  top: calc(50% - 118px);
  //right: 30px;
  .social-icon{
    margin: 25px 0;
    transition-duration: .2s;
    height: 25px;
    width: 25px;
    cursor: pointer;
    img {
      height: 100%;
      width: 100%;
      fill: #FFCB05;
    }
  }
  .social-icon:hover{
    transform: scale(1.5);
  }
}
@media screen and (max-width: 887px){
  .quick-link-container {
    display: none;
  }
}
@media screen and (max-width: 650px){
  .social-media-links{
    width: 100%;
    display: flex;
    right: unset;
    //bottom: 25px;
    bottom: 33px;
    margin: 0;
    justify-content: center;
    align-items: center;
    top: unset;
    left: unset;
    .social-icon{
      margin: 0 10px;
    }
  }
}
@media screen and (max-width: 600px){
  .social-media-links{
    bottom: 82px;
  }
}
</style>
